// src/services/feedbackService.ts
import { useAuthenticatedFetch } from './apiService';

export interface FeedbackType {
  id: string;
  listening_score: string;
  listening_reasoning: string;
  rapport_score: string;
  rapport_reasoning: string;
  articulation_score: string;
  articulation_reasoning: string;
  discovery_score: string;
  discovery_reasoning: string;
  nextsteps_score: string;
  nextsteps_reasoning: string;
  actionable_feedback: string;
  total_score: string;
  salesperson_email: string;
  roleplay_title?: string;
  high_breakpoint: number;
  medium_breakpoint: number;
  low_breakpoint: number;
}

export interface FeedbackItem {
  id: string;
  assignment_id: string;
  scenario_title: string;
  completed_on: Date;
  transcript_id?: number
}

export const useFeedbackService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  return {
    fetchFeedback: async (): Promise<FeedbackItem[]> => {
      const res = await authenticatedFetch('/feedback/');
      if (!res.ok) throw new Error('Failed to load feedback');
      return await res.json();
    },

    fetchSingleFeedback: async (id: string): Promise<FeedbackType> => {
      console.log(`[FeedbackService] Fetching single feedback for id: ${id}`);
      const res = await authenticatedFetch(`/feedback/${id}`);
      if (!res.ok) {
        console.error(`[FeedbackService] Failed to fetch feedback for id: ${id}`, res.status, res.statusText);
        throw new Error('Feedback not found');
      }
      const data = await res.json();
      console.log(`[FeedbackService] Received feedback for id: ${id}:`, data);
      return data;
    }
  };
};